module.exports = __webpack_public_path__ + "img/capslock-fill.d36546db.svg";